import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  getMembershipDetails,
  upgradeToPro,
  downgradeToBasic,
} from '../../services/membershipService';
// import {
//   getMembership,
//   upgradeMembership,
//   purchaseCredits,
// } from '../../services/membershipService';

// import Toast from '../common/Toast';
import { toast } from 'react-toastify';
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});

function MembershipPage() {
  const { restaurantId } = useParams();
  const [membership, setMembership] = useState({});
  const [loading, setLoading] = useState(true);

  const [creditsToPurchase, setCreditsToPurchase] = useState(0);

  // export const getMembershipDetails = async (restaurantId) => {
  //   const response = await api.get(`/restaurants/${restaurantId}/membership`);
  //   return response.data;
  // };

  // const token = localStorage.getItem('ownerToken');
  // const response = await api.get(`/restaurants/${restaurantId}`, {
  //   headers: { Authorization: `Bearer ${token}` },
  // });
  useEffect(() => {
    const fetchMembership = async () => {
      try {
        const token = localStorage.getItem('ownerToken');

        // const data = await getMembershipDetails(restaurantId);
        const data = await api.get(`/restaurants/${restaurantId}/membership`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMembership(data);
      } catch (error) {
        // toast('Error fetching membership details', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchMembership();
  }, [restaurantId]);

  const handleUpgrade = async () => {
    try {
      const data = await upgradeToPro(restaurantId);
      setMembership(data);
      // toast('Membership upgraded to Pro', 'success');
    } catch (error) {
      // toast('Error upgrading membership', 'error');
    }
  };

  const handleDowngrade = async () => {
    try {
      const data = await downgradeToBasic(restaurantId);
      setMembership(data);
      // toast('Membership downgraded to Basic', 'success');
    } catch (error) {
      // toast('Error downgrading membership', 'error');
    }
  };

  useEffect(() => {
    fetchMembership();
  }, [restaurantId]);

  const fetchMembership = async () => {
    try {
      // const data = await getMembership(restaurantId);
      // setMembership(data);
      setLoading(false);
    } catch (error) {
      toast.error('Failed to fetch membership details');
      setLoading(false);
    }
  };

  const handlePurchaseCredits = async () => {
    try {
      // const updatedMembership = await purchaseCredits(
      //   restaurantId,
      //   creditsToPurchase
      // );
      // setMembership(updatedMembership);
      setCreditsToPurchase(0);
      toast.success('Credits purchased successfully');
    } catch (error) {
      toast.error('Failed to purchase credits');
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    // <div className='membership-page'>
    //   <h2>Membership Management</h2>
    //   <p>Current Membership: {membership.type}</p>
    //   <p>Credits Remaining: {membership.credits}</p>
    //   {membership.type === 'basic' ? (
    //     <button onClick={handleUpgrade}>Upgrade to Pro</button>
    //   ) : (
    //     <button onClick={handleDowngrade}>Downgrade to Basic</button>
    //   )}
    // </div>
    <div className='space-y-6'>
      <h2 className='text-2xl font-bold'>Membership</h2>
      <div className='bg-white p-6 rounded shadow'>
        <p>
          <strong>Current Plan:</strong> {membership.type}
        </p>
        <p>
          <strong>Credits:</strong> {membership.credits}
        </p>
        {membership.type !== 'premium' && (
          <button
            onClick={handleUpgrade}
            className='mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded'
          >
            Upgrade Membership
          </button>
        )}
      </div>
      <div className='bg-white p-6 rounded shadow'>
        <h3 className='text-xl font-bold mb-4'>Purchase Credits</h3>
        <div className='flex items-center space-x-4'>
          <input
            type='number'
            value={creditsToPurchase}
            onChange={(e) => setCreditsToPurchase(parseInt(e.target.value))}
            className='block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50'
            min='0'
          />
          <button
            onClick={handlePurchaseCredits}
            className='bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded'
          >
            Purchase
          </button>
        </div>
      </div>

      <section className='py-12 bg-white'>
        <div className='container mx-auto px-6'>
          <h2 className='text-3xl font-semibold text-center mb-8'>
            Membership Plans
          </h2>
          <div className='flex flex-wrap -mx-4'>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Basic</h3>
                <p className='text-4xl font-bold mb-4'>
                  $29<span className='text-sm font-normal'>/month</span>
                </p>
                <ul className='mb-6'>
                  <li>Up to 500 subscribers</li>
                  <li>Basic analytics</li>
                  <li>Email support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Choose Plan
                </a>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full border-2 border-indigo-600'>
                <h3 className='text-xl font-semibold mb-4'>Pro</h3>
                <p className='text-4xl font-bold mb-4'>
                  $79<span className='text-sm font-normal'>/month</span>
                </p>
                <ul className='mb-6'>
                  <li>Up to 2000 subscribers</li>
                  <li>Advanced analytics</li>
                  <li>Priority support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Choose Plan
                </a>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Enterprise</h3>
                <p className='text-4xl font-bold mb-4'>Custom</p>
                <ul className='mb-6'>
                  <li>Unlimited subscribers</li>
                  <li>Custom integrations</li>
                  <li>24/7 dedicated support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default MembershipPage;

// useEffect(() => {
//   fetchMembership();
// }, [restaurantId]);

// const fetchMembership = async () => {
//   try {
//     const data = await getMembership(restaurantId);
//     setMembership(data);
//     setLoading(false);
//   } catch (error) {
//     toast.error('Failed to fetch membership details');
//     setLoading(false);
//   }
// };

// const handleUpgrade = async () => {
//   try {
//     const updatedMembership = await upgradeMembership(restaurantId);
//     setMembership(updatedMembership);
//     toast.success('Membership upgraded successfully');
//   } catch (error) {
//     toast.error('Failed to upgrade membership');
//   }
// };

// const handlePurchaseCredits = async () => {
//   try {
//     const updatedMembership = await purchaseCredits(restaurantId, creditsToPurchase);
//     setMembership(updatedMembership);
//     setCreditsToPurchase(0);
//     toast.success('Credits purchased successfully');
//   } catch (error) {
//     toast.error('Failed to purchase credits');
//   }
// };

// if (loading) {
//   return <div>Loading membership details...</div>;
// }
